<template>
  <div>
    <!-- carousel -->
    <b-carousel id="ads-carousel" :interval="8000" controls indicators background="#ababab">
      <!-- Text slides with image -->
      <a v-for="item in ads" :href="item.link" :key="item.id">
        <b-carousel-slide>
          <template v-slot:img>
            <img class="d-block w-100" :src="item.src" :alt="item.name">
          </template>
        </b-carousel-slide>
      </a>
      <!-- Slides with custom text -->
    </b-carousel>
    <b-container class="mt-5" fluid>
      <b-row v-for="list in favors" :key="list.id" class="py-5 pur-bg">
        <b-col cols="12" class="text-center">
          <h1><span class="mark-top">{{list.title}}</span></h1>
        </b-col>
        <b-col cols="8" offset="2">
          <b-row>
            <b-col lg="3" md="4" sm="6" cols="12" v-for="(item, idx) in list.content" :key="`${item.id}-${idx}`" class="mb-4 p-card">
              <b-card
                border-variant='light'
                img-top
                :title="item.title"
                :img-src="item.img"
                :img-alt="item.info"
                img-height="280"
                @click="$router.push(item.link)"
              >
                <b-card-text class="text-left mb-0">$ {{ item.price }}</b-card-text>
                <b-button class="pull-right more-hover" size="sm" variant="outline-dark" :to="item.link"><font-awesome-icon icon="arrow-right" size="lg" /></b-button>
              </b-card>
            </b-col>
          </b-row>
          <!--hr class="mt-5"-->    
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import pic1 from '../assets/def-banner-1.jpg'
import pic2 from '../assets/def-banner-2.jpg'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
library.add(faArrowRight)
const DefaultSliderData = [{
  id: 'pic-1',
  isDefault: true,
  link: 'javascirpt:void(0)',
  src: pic1
}, {
  id: 'pic-2',
  isDefault: true,
  link: 'javascirpt:void(0)',
  src: pic2
}]
export default {
  data () {
    return {
      ads: [],
      favors: []
    }
  },
  methods: {
    async fetchAds () {
      let list = DefaultSliderData
      try {
        let { data } = await this.$api.getAds()
        if (!data.length) throw new Error('no data')
        data.forEach(item => {
          const { id } = item
          item.src = this.$api.adsImageLink(id)
        })
        list = data
      } catch (err) {
        console.log(err)
      }
      this.ads = list
    },
    async fetchFavors () {
      const { data: list } = await this.$api.getFavor()
      const Cache = new Map()
      const rows = list.sort((a, b) => a.sort - b.sort).map(async flock => {
        const { id, name: title, items } = flock
        const wait = items.map(async catalog => {
          const { id } = catalog
          let promise = Cache.get(id)
          if (!promise) {
            promise = await this.$api.getProd(catalog.id)
            Cache.set(id, promise)
          }
          const { data: { pics, name, description, price, ori_price: oriPrice } } = await promise
          const [ pic ] = pics
          const obj = {
            id,
            title: name,
            info: description,
            price: price || oriPrice,
            link: `/prod/${id}`
          }
          if (pic) {
            obj.img = this.$api.catalogImageLink(id, pic.id)
          }
          return obj
        })
        const content = await Promise.all(wait)
        return { id, title, content }
      })
      this.favors = await Promise.all(rows)
    }
  },
  mounted () {
    this.fetchAds()
    this.fetchFavors()
  }
}
</script>
<style scoped>
  .carousel-inner img {
    display:block;
	position:relative;
	-webkit-transition:all .3s linear;
	transition:all .3s linear;
  }
  .carousel-inner:hover img {
	-ms-transform:scale(1.01);
	-webkit-transform:scale(1.01);
	transform:scale(1.01);
  }
  div.text-center h1 {
    color: #5364b5;/*7b8cde*/
    font-weight: normal;
    padding-bottom: 48px;
    margin-bottom: 0;
	letter-spacing: 0.05em;
	font-size: 2.3rem;
  }
  .mark-top {
    /*border-top: 12px solid #CCC;
    padding: 12px 48px;*/
	
  }
  .empty-card {
    border: none;
    background: none;
  }
  #ads-carousel {
    text-shadow: 1px 1px 2px #333;
  }
  .pur-bg:nth-child(2n) {
    background: #5364b5;
  }
  .pur-bg:nth-child(2n) h1{
    color: #fff;
  }
  .pur-bg:nth-child(2n) .card {
    box-shadow: 0 0 0.5rem #37468b;
    border: none;
  }
  .pur-bg:nth-child(4n) {
    background: #e5ecff;
	background-size: 50px 50px;
	background-image: linear-gradient(-45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);
  }
  .pur-bg:nth-child(4n) h1{
    color: #5364b5;
  }
  .pur-bg:nth-child(4n) .card {
    box-shadow: 0 0 0.5rem #baceff;
    border: none;
  }
</style>